import { useInsuredEmployeesChartQuery } from './queries';
import InsuredEmployeesChartUi from './InsuredEmployeesChart.ui';
import { ChartDataPoint } from './InsuredEmployeesChart.types';

export default function InsuredEmployeesChart() {
  const chartQuery = useInsuredEmployeesChartQuery();

  const chartData: ChartDataPoint[] =
    chartQuery.data?.data.data.map((item) => ({
      type: item.label,
      count: item.count,
    })) || [];

  function handleRetry() {
    chartQuery.refetch();
  }

  return (
    <InsuredEmployeesChartUi
      isLoading={chartQuery.isLoading}
      isError={chartQuery.isError}
      data={chartData}
      onRetry={handleRetry}
    />
  );
}
